import React from 'react';
import { motion } from 'framer-motion';
import ContactSlider from './ContactSlider/ContactSlider';
import { web } from './Contact.constants';
import { contactAnim } from './Contact.anim';
import { useChangeDocumentTitle } from '../../helpers/useChangeDocumentTitle';

export default function Contact({ pageTitle }) {
	useChangeDocumentTitle(pageTitle);

	return (
		<motion.section className='contact' variants={contactAnim} initial='init' animate='anim' exit='end'>
			<ContactSlider category="Contact Info" data={web} />
		</motion.section>
	);
}
